<template>
    <div class="report-catalog rounded bg-white px-2 py-3">

        <div v-if="loading" class="flex min-h-[200px] items-center justify-center">
            <span class="th-loading th-loading-spinner"></span>
        </div>

        <div v-else
             class="report-catalog-main relative flex max-h-[calc(100vh-120px)] flex-col gap-2 overflow-y-auto text-sm leading-5 text-gray-450">

            <div v-for="catalogItem in catalogList" :key="catalogItem.module_type" @click="handleItemClick(catalogItem)"
                 class="report-catalog-item relative cursor-pointer px-2 py-1.5 leading-5 hover:text-eureka-600"
                 :class="{ 'report-catalog-item--activated font-semibold text-eureka-600': catalogItem.task_group_type === activatedCatalog }">
                <span v-html="catalogItem.name"></span>
            </div>

        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeMount } from 'vue';
import { useCatalog } from '@/composables/use-catalog';
import type { CatalogItem } from '@/types';

const props = defineProps<{
    catalogList: CatalogItem[];
    loading: boolean
}>()

const { watch, activatedCatalog, updateViewPort, scrollIntoView } = useCatalog(props)

const handleItemClick = function(catalogItem: CatalogItem) {
    scrollIntoView(catalogItem, (0 - 64 - 60 - 24))
}

let unwatch = () => { };

function updateWindow() {
    const topLine = 200;
    updateViewPort([topLine, Math.max(topLine, window.innerHeight / 2)]);
}

onMounted(() => {
    window.addEventListener('resize', updateWindow);
    unwatch = watch(document.querySelector('.project-report-body'));
    updateWindow();
})

onBeforeMount(() => {
    window.removeEventListener('resize', updateWindow);
    unwatch();
})
</script>

<style lang="scss">
.report-catalog {
    box-shadow: 0px 2px 20px 0px rgba(0, 84, 183, 0.07);

    .report-catalog-item {
        @apply bg-white transition-colors;

        &--activated {
            @apply bg-gradient-to-l from-[#ddebf84d] to-blue-75;

            &::before {
                @apply bg-eureka-500 content-['_'] absolute w-1 h-full rounded-sm left-0 top-0;
            }
        }
    }
}
</style>
